<script setup lang="ts">
import { useCourseStore } from './stores/courseStore';
import MenuOverlay from './components/MenuOverlay.vue';
import PWAInstallPrompt from './components/PWAInstallPrompt.vue';
import DayTabs from './components/DayTabs.vue';
import MaintenanceMessage from './components/MaintenanceMessage.vue';
import UpdateDialog from './components/UpdateDialog.vue';
import { useRouter } from 'vue-router';
import { onMounted } from 'vue';
import { fetchRoomModalSettings } from './services/api';

const store = useCourseStore();
const router = useRouter();

onMounted(async () => {
  // Fetch courses data
  await store.fetchAndUpdateCourses();
  
  // Fetch room modal settings
  try {
    const roomModalEnabled = await fetchRoomModalSettings();
    store.setRoomModalEnabled(roomModalEnabled);
  } catch (error) {
    console.error('Error fetching room modal settings:', error);
    
    // Always set maintenance mode on any error
    store.setMaintenanceMode(true);
    
    // Default to false if there's an error
    store.setRoomModalEnabled(false);
  }
});
</script>

<template>
  <div class="app">
    <PWAInstallPrompt />
    <UpdateDialog />
    <router-view></router-view>
    <DayTabs class="day-tabs-bottom" />
    <div class="menu-button" @click="store.menuOpen = true">
      <div class="hamburger">☰</div>
    </div>
    <MenuOverlay />
    <MaintenanceMessage 
      v-if="store.maintenanceMode" 
      :message="store.maintenanceMessage" 
    />
  </div>
</template>

<style>
.app {
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: fixed;
  background: #f5f5f5;
}

.menu-button {
  /* Temporarily hidden menu button */
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #960040;
  padding: 0.8rem;
  text-align: center;
  cursor: pointer;
  z-index: 10;
}

.hamburger {
  color: white;
  font-size: 1.5rem;
}

.day-tabs-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
}
</style>